import {UniqueIdentifier} from '@dnd-kit/core';

import {prop} from 'ramda';

import i18n from '@dms/i18n';

import {DASHBOARD_TILE_CATALOGUE} from './dashboardTileCatalogue';
import {isDashboardTileId} from './isDashboardTileId';

export const getDashboardTileLabel = (id: UniqueIdentifier) => {
  const tileId = id.toString();

  return isDashboardTileId(tileId)
    ? i18n.t(prop(tileId, DASHBOARD_TILE_CATALOGUE).labelKey)
    : tileId;
};
